import React from 'react';
import styled from 'styled-components';
import theme from 'utils/theme';
const RawMaterialIcon = styled.img `
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
`;
const DEFAULT_COLOR_STATE = {
    default: {
        color: theme.palette.grey.A800,
        backgroundColor: '#fff',
    },
    selected: {
        color: '#fff',
        backgroundColor: theme.palette.grey.A800,
    },
    highlight: { color: '#fff', backgroundColor: theme.backgrounds.grey },
};
const PRIMARY_COLOR_STATE = {
    default: {
        color: theme.palette.grey.A800,
        backgroundColor: '#fff',
    },
    selected: {
        color: theme.palette.grey.A800,
        backgroundColor: theme.palette.primary.main,
    },
    highlight: {
        color: theme.palette.grey.A800,
        backgroundColor: theme.palette.primary.light,
    },
};
const ITEM_VARIANTS = {
    default: DEFAULT_COLOR_STATE,
    primary: PRIMARY_COLOR_STATE,
};
const StyledRawMaterialFilterItem = styled('div') `
  ${({ variant, colorState }) => `background: ${ITEM_VARIANTS[variant][colorState].backgroundColor}`};
  ${({ variant, colorState }) => `color: ${ITEM_VARIANTS[variant][colorState].color}`};
  display: inline-flex;
  padding: 12px;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadiusButton};
  box-shadow: ${({ theme }) => theme.shadows[0]};
  font-weight: 700;
  cursor: pointer;
  height: 38px;
  span {
    max-width: 150px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;
const RawMaterialFilterItem = ({ variant = 'default', selected, highlighted, id, title, imageUrl, onSelect, }) => {
    const colorState = selected
        ? 'selected'
        : highlighted
            ? 'highlight'
            : 'default';
    return (React.createElement(StyledRawMaterialFilterItem, { variant: variant, colorState: colorState, onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(id) },
        imageUrl && React.createElement(RawMaterialIcon, { src: imageUrl }),
        React.createElement("span", null, title)));
};
export default RawMaterialFilterItem;
